<template>
    <section class="content">
        <div class="row center-block">
            <div class="col-md-12">
                <div class="box">
                    <div class="box-header">
                        <!--<h3 class="box-title">Data Table With Full Features</h3>-->
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                        <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div id="example1_length" class="dataTables_length">

                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <table aria-describedby="example1_info" role="grid" id="trip-list" class="table table-bordered table-striped dataTable">
                                        <thead>
                                        <tr role="row">
                                            <th><input class="search-text" id="0" type="text" placeholder="Search" /></th>
                                            <th><input class="search-text" id="1" type="text" placeholder="Search" /></th>
                                            <th><input class="search-text" id="2" type="text" placeholder="Search" /></th>
                                            <th><input class="search-text" id="3" type="text" placeholder="Search" /></th>
                                            <th><select class="search-select" id="4" ><option value="">..</option><option value="0">Done</option><option value="1">Cancel</option></select></th>
                                            <th></th>
                                        </tr>
                                        <tr role="row">
                                            <th>Update Time</th>
                                            <th>Pickup Address</th>
                                            <th>Drop-off Address</th>
                                            <th>Budget</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <th colspan="1" rowspan="1">Update Time</th>
                                            <th colspan="1" rowspan="1">Pickup Point</th>
                                            <th colspan="1" rowspan="1">Dropoff Point</th>
                                            <th colspan="1" rowspan="1">Budget</th>
                                            <th colspan="1" rowspan="1">Status</th>
                                            <th colspan="1" rowspan="1">Action</th>
                                        </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- /.box-body -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import $ from 'jquery'

  // Require needed datatables modules
  require('datatables.net')
  require('datatables.net-bs')

  module.exports = {
    name: 'Tables',
    mounted: function () {
      const state = this.$store.state
      var store = this.$store
      const self = this
      //state.serverURI + 'api/a/driver-list'
      this.$nextTick(function () {
        $('#trip-list tbody').on( 'click', 'a', function () {
          if($(this).attr('class') =="view"){
            self.TripTimeline($(this).attr('id'))
          }
//          else if($(this).attr('class') =="delete"){
//            self.deviceDelete($(this).attr('iid'))
//          }
        })
        var triptable = $('#trip-list').DataTable({
          'processing': true,
          'serverSide': true,
          'aaSorting': [[0, 'desc']],
          "ajax": {
            "url": state.serverURI + 'api/a/trip-list',
            "dataType": 'json',
            "type": "GET",
            "beforeSend": function(xhr){
              xhr.setRequestHeader("Authorization",
                'fb ' + state.user.id + ' ' + state.token );
            },
            'error': function ($xhr) {
              if ($xhr.status === 401) {
                store.dispatch('doSetToken', null )
                store.dispatch('doSetUser', null )

                if (window.localStorage) {
                  window.localStorage.removeItem('user')
                  window.localStorage.removeItem('token')
                }
                self.$router.push( '/login' )
              }
            }
          }, "columnDefs": [
            {
              "render": function ( data, type, row ) {
                return '<a href="javascript:;" class="view" id="'+data+'" ><i class="fa fa-list-alt" aria-hidden="true"></i></a>';
              },
              "targets": -1 ,// column index
              "bSortable": false,
            },{
              "render": function ( data, type, row ) {
                if(data == 1){
                  return 'Cancel'
                }
                return 'Complete';
              },
              "targets": -2 ,// column index
              "bSortable": false,
            }
          ]
        })
        // Apply the search
        $(".search-text").on( 'keyup', function () {
          triptable.column(this.id).search(this.value).draw();
        });
        $(".search-select").on( 'change', function () {
          triptable.column(this.id).search(this.value).draw();
        });
      })
    },methods:{
      TripTimeline: function (id) {
        const self = this
        self.$router.push({name : 'Trip Timeline' , params : {id:id}});
      },
//      deviceDelete:function (iid) {
//        const self = this
//        self.$router.push({name : 'Device Delete' , params : {iid:iid}});
//      }
    }
  }
</script>

<style>
    /* Using the bootstrap style, but overriding the font to not draw in
       the Glyphicons Halflings font as an additional requirement for sorting icons.

       An alternative to the solution active below is to use the jquery style
       which uses images, but the color on the images does not match adminlte.

    @import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
    */

    @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

    table.dataTable thead .sorting:after, table.dataTable thead .sorting_asc:after, table.dataTable thead .sorting_desc:after {
        font-family: 'FontAwesome';
    }

    table.dataTable thead .sorting:after {
        content: "\f0dc";
    }

    table.dataTable thead .sorting_asc:after {
        content: "\f0dd";
    }

    table.dataTable thead .sorting_desc:after {
        content: "\f0de";
    }
</style>



// WEBPACK FOOTER //
// TripList.vue?81866564